import React, { useState } from 'react';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { Button } from '../ui/Button';
import { CheckCircleIcon, AlertCircleIcon, UploadIcon } from 'lucide-react';
export function PartnerForm() {
  const [formData, setFormData] = useState({
    ime: '',
    firma: '',
    grad: '',
    email: '',
    telefon: '',
    iskustvo: '',
    opis: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [fileName, setFileName] = useState<string>('');
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.ime.trim()) newErrors.ime = 'Ime i prezime je obavezno';
    if (!formData.grad.trim()) newErrors.grad = 'Grad je obavezan';
    if (!formData.email.trim()) {
      newErrors.email = 'Email je obavezan';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Email adresa nije validna';
    }
    if (!formData.telefon.trim()) newErrors.telefon = 'Telefon je obavezan';
    if (!formData.iskustvo.trim()) newErrors.iskustvo = 'Godine iskustva su obavezne';
    if (!formData.opis.trim()) newErrors.opis = 'Opis rada je obavezan';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsSubmitting(true);
    setSubmitStatus('idle');
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      setSubmitStatus('success');
      setFormData({
        ime: '',
        firma: '',
        grad: '',
        email: '',
        telefon: '',
        iskustvo: '',
        opis: ''
      });
      setFileName('');
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);
    }
  };
  return <form onSubmit={handleSubmit} className="space-y-5" data-id="element-420">
      <Input label="Ime i prezime *" type="text" placeholder="Vaše ime i prezime" value={formData.ime} onChange={e => setFormData({
      ...formData,
      ime: e.target.value
    })} error={errors.ime} data-id="element-421" />

      <Input label="Naziv firme" type="text" placeholder="Naziv firme (opciono)" value={formData.firma} onChange={e => setFormData({
      ...formData,
      firma: e.target.value
    })} data-id="element-422" />

      <Input label="Grad / Okrug *" type="text" placeholder="Vaš grad ili okrug" value={formData.grad} onChange={e => setFormData({
      ...formData,
      grad: e.target.value
    })} error={errors.grad} data-id="element-423" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-424">
        <Input label="Telefon *" type="tel" placeholder="+381 ..." value={formData.telefon} onChange={e => setFormData({
        ...formData,
        telefon: e.target.value
      })} error={errors.telefon} data-id="element-425" />
        <Input label="Email *" type="email" placeholder="vas@email.com" value={formData.email} onChange={e => setFormData({
        ...formData,
        email: e.target.value
      })} error={errors.email} data-id="element-426" />
      </div>

      <Input label="Godine iskustva *" type="text" placeholder="npr. 5 godina" value={formData.iskustvo} onChange={e => setFormData({
      ...formData,
      iskustvo: e.target.value
    })} error={errors.iskustvo} data-id="element-427" />

      <Textarea label="Kratak opis dosadašnjeg rada *" placeholder="Opišite vaše iskustvo..." rows={4} value={formData.opis} onChange={e => setFormData({
      ...formData,
      opis: e.target.value
    })} error={errors.opis} data-id="element-428" />

      <div data-id="element-429">
        <label className="block text-sm font-semibold text-white mb-2" data-id="element-430">
          Dokumentacija (opciono)
        </label>
        <label className="flex items-center justify-center gap-3 px-6 py-4 bg-dark-surface border-2 border-dashed border-dark-border rounded-industrial cursor-pointer hover:border-brand-yellow transition-colors" data-id="element-431">
          <UploadIcon className="w-5 h-5 text-gray-400" data-id="element-432" />
          <span className="text-sm text-gray-400" data-id="element-433">
            {fileName || 'Izaberite fajl (PDF, DOC)'}
          </span>
          <input type="file" className="hidden" accept=".pdf,.doc,.docx" onChange={handleFileChange} data-id="element-434" />
        </label>
      </div>

      {submitStatus === 'success' && <div className="flex items-center gap-3 p-4 bg-green-500/10 border border-green-500/30 rounded-industrial" data-id="element-435">
          <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-436" />
          <div data-id="element-437">
            <p className="text-sm font-semibold text-green-500" data-id="element-438">
              Prijava je uspešno poslata!
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-439">
              Kontaktiraćemo vas u najkraćem roku.
            </p>
          </div>
        </div>}

      {submitStatus === 'error' && <div className="flex items-center gap-3 p-4 bg-red-500/10 border border-red-500/30 rounded-industrial" data-id="element-440">
          <AlertCircleIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-441" />
          <p className="text-sm text-red-500" data-id="element-442">
            Greška pri slanju. Pokušajte ponovo.
          </p>
        </div>}

      <Button type="submit" variant="primary" size="lg" className="w-full" disabled={isSubmitting} data-id="element-443">
        {isSubmitting ? 'Slanje...' : 'Prijavite se za servisnu saradnju'}
      </Button>

      <p className="text-xs text-gray-500 text-center" data-id="element-444">
        Svi podaci se koriste isključivo u svrhu evaluacije prijave.
      </p>
    </form>;
}